import type {ErrorObject} from "@vuelidate/core";
import {html as beautifyHtml} from 'js-beautify';

function handleError(error: ErrorObject[] | undefined) {
    if (error && error.length > 0) {
        const message = error[0].$message;
        return typeof message === 'string' ? message : '';
    }
    return '';
}

function formatHtml(content: string) {
    return beautifyHtml(content, {
        indent_size: 2,
        indent_with_tabs: false,
        preserve_newlines: true,
        max_preserve_newlines: 2,
        wrap_line_length: 120,
        end_with_newline: true,
    });
}

function getNextBaseText(baseText: string) {
    const match = baseText.match(/^(.*)_(\d+)$/);

    if (match) {
        const base = match[1];
        const num = parseInt(match[2], 10);
        return `${base}_${num + 1}`;
    } else {
        return `${baseText}_1`;
    }
}

export {handleError, getNextBaseText, formatHtml};